import React from 'react'
import './styles.scss'
import building from 'assets/portfolio/image/building.png'
import clock from 'assets/portfolio/image/ClockOutline.png'
import data_experience from 'data/portfolio/experience'
import ExperienceCard from './ExperienceCard'

const Experience = () => {
  return (
    <div className="experience">
      <h3>Work Experiences</h3>
      <p className="short-intro-experience">
        Passionate to craft amazing digital products. we can provide your business with a new
        creative start right away!
      </p>
      <div className="frame-general-experience">
        <div className="experience-left">
          <h5>Front - End Developer Intern</h5>
          <div className="frame-icon">
            <img src={building} alt="" />
            <p>Simpson Strong-Tie</p>
          </div>
          <div className="frame-icon">
            <img src={clock} alt="" />
            <p>July 2023 - current</p>
          </div>
        </div>
        <div className="experience-right">
          <h5>Frontend Engineer</h5>
          <p>
            Implementation: Writing code to build UI and features. <br /> Deployment: Making the app
            available online. <br />
            Demonstration: Showcasing functionality to stakeholders and user interactions.
          </p>
        </div>
      </div>

      <hr className="line-top" />
      <div className="main-frame-card">
        <div className="frame-card">
          {data_experience.map((item, index) => (
            <ExperienceCard key={index} name={item.name} experiences={item.experiences} />
          ))}
        </div>
      </div>
      <hr className="line-bottom" />
    </div>
  )
}

export default Experience
